import { FeedbackResolution } from './interfaces/review-feedback.interface';

export interface ResolutionOption {
  value: FeedbackResolution;
  label: string;
  icon: string;
  hint: string;
  color: string;
}

export const FINDING_RESOLUTIONS: ResolutionOption[] = [
  { value: 'true_positive',  label: 'Procede',          icon: 'po-icon-ok',           color: '#00b283', hint: 'Problema real, deve ser corrigido' },
  { value: 'false_positive', label: 'Falso positivo',   icon: 'po-icon-warning',      color: '#c64840', hint: 'Não é um problema real neste código' },
  { value: 'wont_fix',       label: 'Não vou corrigir', icon: 'po-icon-minus-circle', color: '#c8860d', hint: 'Problema real, mas não será corrigido' }
];

/**
 * Resoluções que só são aceitas com justificativa — a mesma regra do backend
 * (`RequiresComment`). O porquê de um falso positivo ou de um "não vou corrigir" é o que
 * a curadoria usa para separar erro do modelo de regra de negócio que ele não conhecia.
 */
export function resolutionRequiresComment(resolution: FeedbackResolution | null): boolean {
  return resolution === 'false_positive' || resolution === 'wont_fix';
}

export const OVERALL_RESOLUTIONS: ResolutionOption[] = [
  { value: 'true_positive',  label: 'Review preciso',   icon: 'po-icon-ok',           color: '#00b283', hint: 'Achados são problemas reais' },
  { value: 'false_positive', label: 'Review impreciso', icon: 'po-icon-warning',      color: '#c64840', hint: 'Muitos achados não procedem' },
  { value: 'wont_fix',       label: 'Não aplicarei',    icon: 'po-icon-minus-circle', color: '#c8860d', hint: 'Achados procedem, mas não serão corrigidos' }
];

